import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Lock, Mail, ArrowRight, ShieldCheck } from "lucide-react";
import ToastHelper from "@/utils/toastHelper";
import { useStudentLogin } from "@/hooks/useStudentLogin";

export default function Login() {
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const { login, loading } = useStudentLogin();

  const submit = async (e) => {
    e.preventDefault();
    const result = await login(f.email, f.password);

    if (result.success) {
      localStorage.setItem("token", result.data.token);
      ToastHelper.success(result.message);
      nav("/student/dashboard", { replace: true });
    } else {
      ToastHelper.error(result.message);
    }
  };
  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="wc-card p-8">
        <div className="w-12 h-12 rounded-xl bg-[#0A2540] text-white flex items-center justify-center mb-4 mx-auto"><Lock className="w-5 h-5" /></div>
        <h1 className="text-2xl font-display font-extrabold text-[#0A2540] text-center">Student Login</h1>
        <p className="text-sm text-slate-500 text-center mt-1 mb-6">Welcome back — sign in to your student portal.</p>
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <div><label className="wc-label">Email</label>
            <div className="relative"><Mail className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
              <input required type="email" className="wc-input pl-9" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="login-email" /></div>
          </div>
          <div><label className="wc-label">Password</label>
            <div className="relative"><Lock className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
              <input required type="password" className="wc-input pl-9" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="login-password" /></div>
          </div>
          <div className="flex justify-between text-sm">
            <label className="inline-flex items-center gap-2 text-slate-600"><input type="checkbox" className="rounded" /> Remember me</label>
            <Link to="/forgot-password" className="text-[#0A2540] font-semibold hover:text-orange-600">Forgot password?</Link>
          </div>
          <button type="submit" disabled={loading} className="wc-btn-primary w-full justify-center" data-testid="login-submit">
            {loading ? <><span className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" /> Signing in...</> : <>Sign in <ArrowRight className="w-4 h-4" /></>}
          </button>
        </form>
        <div className="mt-5 text-center text-sm text-slate-600">No account? <Link to="/register" className="font-semibold text-[#0A2540] hover:text-orange-600">Create one</Link></div>
        <div className="mt-6 pt-5 border-t border-slate-200 flex items-center gap-2 text-xs text-slate-500 justify-center"><ShieldCheck className="w-3.5 h-3.5" />Secured with bank-grade encryption</div>
      </div>
    </div>
  );
}
